export default "__VITE_ASSET__DO1B5J09__"